import request from '@/utils/request'


// 查询食谱列表
export function listCookbook(query) {
  return request({
    url: '/cookbook/cookbook/list',
    method: 'get',
    params: query
  })
}

// 查询食谱分页
export function pageCookbook(query) {
  return request({
    url: '/cookbook/cookbook/page',
    method: 'get',
    params: query
  })
}

// 查询食谱详细
export function getCookbook(data) {
  return request({
    url: '/cookbook/cookbook/detail',
    method: 'get',
    params: data
  })
}

// 新增食谱
export function addCookbook(data) {
  return request({
    url: '/cookbook/cookbook/add',
    method: 'post',
    data: data
  })
}

// 修改食谱
export function updateCookbook(data) {
  return request({
    url: '/cookbook/cookbook/edit',
    method: 'post',
    data: data
  })
}

// 删除食谱
export function delCookbook(data) {
  return request({
    url: '/cookbook/cookbook/delete',
    method: 'post',
    data: data
  })
}
